import axios from '@/axios'
import * as types from '../mutation-types'

export default {
  namespaced: true,

  state: {
    news: [
      {
        id: 17,
        title: 'AI-Powered Drones Now Managing Warehouse Inventory',
        content: '<p>Drones use computer vision to identify misplaced items instantly.<br>Reduces stock discrepancies by 95% compared to human checks.<br>Cuts warehouse operational costs by 30%.<br>Future models may predict stockouts before they happen.<br>Privacy concerns arise over AI surveillance in workplaces.</p>',
        summary: 'Amazon and Walmart deploy autonomous drones to scan and track inventory in real-time, replacing manual stock checks.',
        code: null,
        date: '2025-06-02 00:00:00',
        isFeatured: false,
        inHomePage: true,
        num: 13,
        primaryImage: {
          id: 119,
          name: 'bde33f3c-3edc-434a-853b-4e3081aacc8d',
          fileName: 'suWLaBpKeYs5pcq7vHcQlXGTd0fAyRI15t8rMg13.png',
          collection: 'news',
          url: 'https://api.solinics.com/storage/119/suWLaBpKeYs5pcq7vHcQlXGTd0fAyRI15t8rMg13.png',
          publicPath: '/storage/119/suWLaBpKeYs5pcq7vHcQlXGTd0fAyRI15t8rMg13.png',
          size: '720 KB',
          type: 'image',
          extension: 'png',
          caption: 'bde33f3c-3edc-434a-853b-4e3081aacc8d',
          width: 768,
          height: 768
        },
        slug: 'ai-powered-drones-now-managing-warehouse-inventory',
        descriptionSeo: '',
        keywordsSeo: '',
        deletedAt: null,
        filterIds: [],
        images: [
          {
            id: 119,
            name: 'bde33f3c-3edc-434a-853b-4e3081aacc8d',
            fileName: 'suWLaBpKeYs5pcq7vHcQlXGTd0fAyRI15t8rMg13.png',
            collection: 'news',
            url: 'https://api.solinics.com/storage/119/suWLaBpKeYs5pcq7vHcQlXGTd0fAyRI15t8rMg13.png',
            publicPath: '/storage/119/suWLaBpKeYs5pcq7vHcQlXGTd0fAyRI15t8rMg13.png',
            size: '720 KB',
            type: 'image',
            extension: 'png',
            caption: 'bde33f3c-3edc-434a-853b-4e3081aacc8d',
            width: 768,
            height: 768
          }
        ],
        filters: [],
        benefits: []
      },
      {
        id: 20,
        title: 'Microsoft Integrates ChatGPT into Dynamics 365 for Smarter ERP',
        content: '<p>Employees can ask AI in natural language for business insights.<br>ChatGPT drafts contracts, invoices, and compliance reports instantly.<br>Reduces manual data entry by 70%.<br>Early adopters report higher productivity and fewer errors.<br>Future updates may include voice-controlled ERP navigation.</p>',
        summary: 'Microsoft’s ERP system now uses ChatGPT-4 to generate financial reports, automate emails, and optimize workflows.',
        code: null,
        date: '2025-06-09 00:00:00',
        isFeatured: false,
        inHomePage: false,
        num: 12,
        primaryImage: {
          id: 118,
          name: '390a8029-6097-402a-b288-c9b4d98d39fb',
          fileName: 'jybQqBPLfqUB6iHwgiDNeoHhEd7h1HsqEH8m2oVp.png',
          collection: 'news',
          url: 'https://api.solinics.com/storage/118/jybQqBPLfqUB6iHwgiDNeoHhEd7h1HsqEH8m2oVp.png',
          publicPath: '/storage/118/jybQqBPLfqUB6iHwgiDNeoHhEd7h1HsqEH8m2oVp.png',
          size: '521.79 KB',
          type: 'image',
          extension: 'png',
          caption: '390a8029-6097-402a-b288-c9b4d98d39fb',
          width: 768,
          height: 768
        },
        slug: 'microsoft-integrates-chatgpt-into-dynamics-365-for-smarter-erp',
        descriptionSeo: '',
        keywordsSeo: '',
        deletedAt: null,
        filterIds: [],
        images: [
          {
            id: 118,
            name: '390a8029-6097-402a-b288-c9b4d98d39fb',
            fileName: 'jybQqBPLfqUB6iHwgiDNeoHhEd7h1HsqEH8m2oVp.png',
            collection: 'news',
            url: 'https://api.solinics.com/storage/118/jybQqBPLfqUB6iHwgiDNeoHhEd7h1HsqEH8m2oVp.png',
            publicPath: '/storage/118/jybQqBPLfqUB6iHwgiDNeoHhEd7h1HsqEH8m2oVp.png',
            size: '521.79 KB',
            type: 'image',
            extension: 'png',
            caption: '390a8029-6097-402a-b288-c9b4d98d39fb',
            width: 768,
            height: 768
          }
        ],
        filters: [],
        benefits: []
      },
      {
        id: 16,
        title: 'AI-Powered Drones Now Managing Warehouse Inventory',
        content: '<p>Drones use computer vision to identify misplaced items instantly.<br>Reduces stock discrepancies by 95% compared to human checks.<br>Cuts warehouse operational costs by 30%.<br>Future models may predict stockouts before they happen.<br>Privacy concerns arise over AI surveillance in workplaces.</p>',
        summary: 'Amazon and Walmart deploy autonomous drones to scan and track inventory in real-time, replacing manual stock checks.',
        code: null,
        date: '2025-06-02 00:00:00',
        isFeatured: false,
        inHomePage: true,
        num: 13,
        primaryImage: {
          id: 119,
          name: 'bde33f3c-3edc-434a-853b-4e3081aacc8d',
          fileName: 'suWLaBpKeYs5pcq7vHcQlXGTd0fAyRI15t8rMg13.png',
          collection: 'news',
          url: 'https://api.solinics.com/storage/119/suWLaBpKeYs5pcq7vHcQlXGTd0fAyRI15t8rMg13.png',
          publicPath: '/storage/119/suWLaBpKeYs5pcq7vHcQlXGTd0fAyRI15t8rMg13.png',
          size: '720 KB',
          type: 'image',
          extension: 'png',
          caption: 'bde33f3c-3edc-434a-853b-4e3081aacc8d',
          width: 768,
          height: 768
        },
        slug: 'ai-powered-drones-now-managing-warehouse-inventory',
        descriptionSeo: '',
        keywordsSeo: '',
        deletedAt: null,
        filterIds: [],
        images: [
          {
            id: 119,
            name: 'bde33f3c-3edc-434a-853b-4e3081aacc8d',
            fileName: 'suWLaBpKeYs5pcq7vHcQlXGTd0fAyRI15t8rMg13.png',
            collection: 'news',
            url: 'https://api.solinics.com/storage/119/suWLaBpKeYs5pcq7vHcQlXGTd0fAyRI15t8rMg13.png',
            publicPath: '/storage/119/suWLaBpKeYs5pcq7vHcQlXGTd0fAyRI15t8rMg13.png',
            size: '720 KB',
            type: 'image',
            extension: 'png',
            caption: 'bde33f3c-3edc-434a-853b-4e3081aacc8d',
            width: 768,
            height: 768
          }
        ],
        filters: [],
        benefits: []
      },
      {
        id: 15,
        title: 'Microsoft Integrates ChatGPT into Dynamics 365 for Smarter ERP',
        content: '<p>Employees can ask AI in natural language for business insights.<br>ChatGPT drafts contracts, invoices, and compliance reports instantly.<br>Reduces manual data entry by 70%.<br>Early adopters report higher productivity and fewer errors.<br>Future updates may include voice-controlled ERP navigation.</p>',
        summary: 'Microsoft’s ERP system now uses ChatGPT-4 to generate financial reports, automate emails, and optimize workflows.',
        code: null,
        date: '2025-06-09 00:00:00',
        isFeatured: false,
        inHomePage: false,
        num: 12,
        primaryImage: {
          id: 118,
          name: '390a8029-6097-402a-b288-c9b4d98d39fb',
          fileName: 'jybQqBPLfqUB6iHwgiDNeoHhEd7h1HsqEH8m2oVp.png',
          collection: 'news',
          url: 'https://api.solinics.com/storage/118/jybQqBPLfqUB6iHwgiDNeoHhEd7h1HsqEH8m2oVp.png',
          publicPath: '/storage/118/jybQqBPLfqUB6iHwgiDNeoHhEd7h1HsqEH8m2oVp.png',
          size: '521.79 KB',
          type: 'image',
          extension: 'png',
          caption: '390a8029-6097-402a-b288-c9b4d98d39fb',
          width: 768,
          height: 768
        },
        slug: 'microsoft-integrates-chatgpt-into-dynamics-365-for-smarter-erp',
        descriptionSeo: '',
        keywordsSeo: '',
        deletedAt: null,
        filterIds: [],
        images: [
          {
            id: 118,
            name: '390a8029-6097-402a-b288-c9b4d98d39fb',
            fileName: 'jybQqBPLfqUB6iHwgiDNeoHhEd7h1HsqEH8m2oVp.png',
            collection: 'news',
            url: 'https://api.solinics.com/storage/118/jybQqBPLfqUB6iHwgiDNeoHhEd7h1HsqEH8m2oVp.png',
            publicPath: '/storage/118/jybQqBPLfqUB6iHwgiDNeoHhEd7h1HsqEH8m2oVp.png',
            size: '521.79 KB',
            type: 'image',
            extension: 'png',
            caption: '390a8029-6097-402a-b288-c9b4d98d39fb',
            width: 768,
            height: 768
          }
        ],
        filters: [],
        benefits: []
      }
    ]
  },

  actions: {
    fetchAll ({ commit }) {
      return axios.get('/news').then((response) => {
        commit(types.STORE_NEWS, response.data)
      })
    },

    fetch ({ commit }, { id }) {
      return axios.get(`/news/${id}`).then((response) => {
        commit(types.STORE_ONE_NEWS, response.data)
      })
    }
  },

  mutations: {
    [types.STORE_NEWS] (state, news) {
      state.news = news
    }
  },

  getters: {
    getBySlug: (state) => (slug) => state.news.find((t) => t.slug === slug)
  }
}
